
(function(document) {

  let selectors = {
    productVariants: '.js-product-variant:not(.is-disabled)',
    productVariantsDisabled: '.js-product-variant.is-disabled',
    submitButton: '.js-add-to-cart',
    cartTrigger: '.is-cart',
    cartBtnsMinus: '.cart-qnt-btn-minus',
    cartBtnsPlus: '.cart-qnt-btn-plus',
    cartItems: '.c-cart-item',
    cartItemsLine: '.c-header-cart__line',
    cartItemsTot: '.c-cart-item__quantity-tot',
    cartSummary: '.c-header-cart__summary',
    msgEmptyCart: '.msg-empty-cart',
    cartCount: '.js-cart-count',
    cartInfoHidden: '#cart-info-hidden',
    variantNotification: '.js-variant-notification',
    borderNotification: '.js-border-notification',
    cartItemRemoves: '.js-cart-item-remove',
  };

  let productVariants = document.querySelectorAll(selectors.productVariants)
  let productVariantsDisabled = document.querySelectorAll(selectors.productVariantsDisabled)
  let submitButton = document.querySelector(selectors.submitButton)
  let cartTrigger = document.querySelector(selectors.cartTrigger)
  let cartBtnsMinus = document.querySelectorAll(selectors.cartBtnsMinus)
  let cartBtnsPlus = document.querySelectorAll(selectors.cartBtnsPlus)
  let cartItems = document.querySelectorAll(selectors.cartItems)
  let cartItemsLine = document.querySelectorAll(selectors.cartItemsLine)
  let cartItemsTot = document.querySelectorAll(selectors.cartItemsTot)
  let cartSummary = document.querySelector(selectors.cartSummary)
  let msgEmptyCart = document.querySelector(selectors.msgEmptyCart)
  let cartCount = document.querySelector(selectors.cartCount)
  let cartInfoHidden = document.querySelector(selectors.cartInfoHidden)
  let variantNotification = document.querySelector(selectors.variantNotification)
  let borderNotification = document.querySelector(selectors.borderNotification)
  let cartItemRemoves = document.querySelectorAll(selectors.cartItemRemoves);

  let itemList = { "items" : [], 'sections': 'cart-ajax' }

  // a11y: annunci per screen reader nella regione #a11y-cart-status (snippet product-form)
  let a11yCartStatus = document.getElementById('a11y-cart-status')
  function a11yAnnounce(key, text) {
    if (!a11yCartStatus) return
    a11yCartStatus.textContent = ''
    setTimeout(function () { a11yCartStatus.textContent = text || a11yCartStatus.dataset[key] || '' }, 100)
  }

  // a11y: nomi tradotti di +/− e cestino per l'HTML ricostruito da reloadCart (testi in data-label-* su #cart-ajax)
  function a11yEsc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  }
  function a11yCartLabel(key, title) {
    let cartAjax = document.getElementById('cart-ajax')
    let label = cartAjax && cartAjax.getAttribute('data-label-' + key)
    return label ? ' aria-label="' + a11yEsc(label.replace('%s', function () { return title })) + '"' : ''
  }

  window.addEventListener("load", (event) => {

    cartItemRemoves = document.querySelectorAll(selectors.cartItemRemoves);

    cartItemRemoves.forEach((cartItemRemove,i) => {
      cartItemRemove.addEventListener("click", (e) => {

        console.log("remove")

          cartItemRemove.classList.add("disable")

          let dataID = cartItemRemove.getAttribute("data-id")
          let dataQnt = cartItemRemove.getAttribute("data-qnt")

          let changeVariant = {
                'id': dataID,
                'quantity': dataQnt
              }

          changeCart(changeVariant, cartItemRemove, 0)
      })
    }) 

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let paramOpenCart = urlParams.get('opencart')
    if (paramOpenCart == "true") {
        cartTrigger.click()
        var scrollpos = localStorage.getItem('scrollpos');
        if (scrollpos) window.scrollTo({
            top: scrollpos,
            behavior: "smooth",
          });
    }

    window.onbeforeunload = function(e) {
        localStorage.setItem('scrollpos', window.scrollY);
    };

    productVariantsDisabled.forEach((productVariantDisabled,i) => {
      productVariantDisabled.addEventListener("click", (e) => {
        productVariants.forEach((productVariant,i) => {
          productVariant.classList.remove("selected")
        })
      })
    })

    productVariants.forEach((productVariant,i) => {

      productVariant.addEventListener("click", (e) => {

        itemList.items = []

        if ( productVariant.classList.contains("selected") ) {

          productVariant.classList.remove("selected")

        } else {

          productVariants.forEach((productVariant__clean) => {
            productVariant__clean.classList.remove("selected")
          })

          productVariant.classList.add("selected")

          let productVariant__id = productVariant.querySelector("input").getAttribute("variant-id")
  
          jsonVariant = {
            'id': productVariant__id,
            'quantity': 1
          }
          itemList.items.push(jsonVariant)
          
        }

      }, false)
          
    })

    if (submitButton) {
        submitButton.addEventListener("click", (e) => {
    
          if (submitButton.classList.contains("disabled")) return // a11y: niente doppio invio mentre la richiesta è in corso
          submitButton.classList.add("disabled")
          cartSummary.classList.remove("hide")
          
          let variant_select = false
          productVariants.forEach((productVariant__check) => {
            if (productVariant__check.classList.contains("selected")) {
              variant_select = true
            }
          })

          if (variant_select) {

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(itemList)
            }).then(response => {
              return response.json();
            }).then(data => {
      
              // console.log(data);
      
              submitButton.classList.remove("disabled")
              a11yAnnounce(data && data.status ? 'error' : 'added', data && data.status ? data.description : '')
              
              let disablePlus = false
      
              reloadCart(disablePlus)

              setTimeout(() => {
                window.e.emit('app:open_cart');
              }, 500);
      
            }).catch((error) => {
              console.error('Error:', error);
              submitButton.classList.remove("disabled")
              a11yAnnounce('error')
            });

          } else {

            variantNotification.classList.remove("hidden")
            a11yAnnounce('', variantNotification.textContent.trim())
            borderNotification.classList.remove("hidden")
            setTimeout(function(){
              variantNotification.classList.add("hidden")
              borderNotification.classList.add("hidden")
            }, 2500)

            submitButton.classList.remove("disabled")
          }
    
        }, false)
    }

    function changeCart(changeVariant, cartBtnVariation, limit) {
      fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(changeVariant)
        }).then(response => {
          return response.json();
        }).then(data => {
          
          console.log(data);
          // console.log(data.total_price);
          // console.log(data.items);

          // Reloat Cart Total
          let newTotal = (parseInt(data.total_price)).toFixed(2) / 100
          let cartTotal = document.querySelector(".c-header-cart__total")
          let cartTotalVal = cartTotal.querySelector(".c-header-cart__total__val")
          let currentCurency = cartTotal.getAttribute("data-currency")
          let itemsCartCount = document.querySelector(".js-items-cart-count")
          
          cartTotalVal.innerHTML = currentCurency + newTotal
          
          // Conteggio items
          itemsCartCount.innerHTML = data.item_count

          // Ricalcolo totale del prodotto (line item)
          data.items.forEach(itemCart => {
            if (itemCart.id == changeVariant.id ) {
              console.log("trovato: "+itemCart.id+" - "+changeVariant.id)
              document.querySelector('.c-cart-item[data-id="'+changeVariant.id+'"] .c-cart-item__price').innerHTML = currentCurency + (parseInt(itemCart.original_line_price)).toFixed(2) / 100
            }
          });

          // Remove Item = 0
          if (changeVariant.quantity == 0) {
            let removedItem = document.querySelector('.c-cart-item[data-id="'+changeVariant.id+'"]')
            if (removedItem) {
              // a11y: il focus passa al cestino dell'articolo vicino (o alla X del carrello) invece di finire sul body
              let hadFocus = removedItem.contains(document.activeElement)
              let nearItem = removedItem.nextElementSibling
              if (!nearItem || !nearItem.querySelector('.js-cart-item-remove')) nearItem = removedItem.previousElementSibling
              removedItem.remove()
              if (hadFocus) {
                let nextFocus = (nearItem && nearItem.querySelector('.js-cart-item-remove')) || document.querySelector('.js-cart-close')
                if (nextFocus) nextFocus.focus()
              }
            }
          }

          // Reload page if empty cart
          if (data.item_count == 0) {
            location.assign(location.protocol + '//' + location.host + location.pathname)
            return;
          }

          // Reset all cart items quantity
          data.items.forEach((cartItem,i) => {

            let currentItem = document.querySelector('.c-cart-item[data-id="'+cartItem.id+'"]')
            let btnMinus = currentItem.querySelector(".cart-qnt-btn-minus")
            let btnPlus = currentItem.querySelector(".cart-qnt-btn-plus")

            currentItem.querySelector(".c-cart-item__quantity-tot").innerHTML = cartItem.quantity
            btnMinus.setAttribute("data-qnt", cartItem.quantity - 1)
            if (cartItem.quantity == limit) {
              btnPlus.classList.add("disabled")
            } else {
              btnPlus.classList.remove("disabled")
              btnPlus.setAttribute("data-qnt", cartItem.quantity + 1)
            }
            
          })

          // Re-enable btn variation
          cartBtnVariation.classList.remove("disable")
          
        }).catch((error) => {
          console.error('Error:', error);
        });
    }

    listenerMinus(cartBtnsMinus)

    function listenerMinus(cartBtnsMinus) {

      cartBtnsMinus.forEach((cartBtnMinus,i) => {
        cartBtnMinus.addEventListener("click", (e) => {

          cartBtnMinus.classList.add("disable")

          let dataID = cartBtnMinus.getAttribute("data-id")
          let dataQnt = cartBtnMinus.getAttribute("data-qnt")

          let currentItem = document.querySelector('.js-cart-item-limit[data-id="'+dataID+'"]')
          let currentLimit = currentItem.getAttribute("data-limit")
          let currentLimit__qnt = parseInt(currentLimit)

          let changeVariant = {
                'id': dataID,
                'quantity': dataQnt
              }

          changeCart(changeVariant, cartBtnMinus, currentLimit__qnt)

        }, false)
      })

    }

    listenerPlus(cartBtnsPlus) 
    
    function listenerPlus(cartBtnsPlus) {
      cartBtnsPlus.forEach((cartBtnPlus,i) => {
        cartBtnPlus.addEventListener("click", (e) => {

          cartBtnPlus.classList.add("disable")

          let dataID = cartBtnPlus.getAttribute("data-id")
          let dataQnt = cartBtnPlus.getAttribute("data-qnt")

          // console.log(dataID)

          let currentItem = document.querySelector('.js-cart-item-limit[data-id="'+dataID+'"]')
          let currentLimit = currentItem.getAttribute("data-limit")
          let currentLimit__qnt = parseInt(currentLimit)

          // console.log(currentLimit__qnt)

          let changeVariant = {
                'id': dataID,
                'quantity': dataQnt
              }

          changeCart(changeVariant, cartBtnPlus, currentLimit__qnt)

        }, false)
      })
    }


    function reloadCart(disablePlus) {

      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        return response.json();
      }).then(data => {

        console.log(data); // prints HTML of the section 

        let cartAjax = document.querySelector('#cart-ajax')
        cartAjax.innerHTML = ""

        // console.log(data.items)
        // console.log(data.item_count)
        
        uploadCartCount(data.item_count)
        resetCartHidden(data.items)

        data.items.forEach((cartItem,i) => {

          let quantityMinus = cartItem.quantity - 1
          let quantityPlus = cartItem.quantity + 1
          let disablePlusClass = ""

          let cartTotal = document.querySelector(".c-header-cart__total")
          let cartTotalVal = cartTotal.querySelector(".c-header-cart__total__val")
          let currentCurency = cartTotal.getAttribute("data-currency")

          cartTotalVal.innerHTML = (currentCurency + (data.total_price / 100))

          let finalPrice = (currentCurency + (cartItem.final_price / 100))
          // let finalPrice = (currentCurency + (cartItem.final_price / 100)).toFixed(2)

          if (disablePlus) {
            let disablePlusClass = "disabled"
          }

          var divCartItem = document.createElement('div');
          divCartItem.setAttribute('class', 'c-cart-item');
          divCartItem.setAttribute('data-id', cartItem.id);

          let discount_mex
          cartItem.discounts[0] ? discount_mex = cartItem.discounts[0].title : discount_mex = ""

          divCartItem.innerHTML = `
                    <div class="c-cart-item__container">
                        <a class="c-cart-item__image" href="`+cartItem.url+`">
                            <img src="`+cartItem.image+`&width=150" alt="`+a11yEsc(cartItem.title)+`">
                        </a>
                        <div class="c-cart-item__info">
                          <strong>`+a11yEsc(cartItem.title)+`</strong>
                          <span>`+discount_mex+`</span>
                          <div class="c-cart-item__quantity">

                            <button 
                                class="c-cart-item__quantity-btn cart-qnt-btn-minus" 
                                type="button" 
                                data-id="`+cartItem.id+`" 
                                data-qnt="`+quantityMinus+`"`+a11yCartLabel('decrease', cartItem.title)+` >
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 18C14.1944 18 18 14.1944 18 9.5C18 4.80558 14.1944 1 9.5 1C4.80558 1 1 4.80558 1 9.5C1 14.1944 4.80558 18 9.5 18Z" stroke="#0B0204" stroke-width="1.5" stroke-miterlimit="10"/><path d="M5.76074 9.5H13.2414" stroke="#0B0204" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/></svg>
                            </button>
                              
                            <span class="c-cart-item__quantity-tot">`+cartItem.quantity+`</span>
                              
                            <button 
                                class="c-cart-item__quantity-btn cart-qnt-btn-plus `+disablePlusClass+`" 
                                type="button" 
                                data-id="`+cartItem.id+`" 
                                data-qnt="`+quantityPlus+`"`+a11yCartLabel('increase', cartItem.title)+` >
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.49902 18.002C14.194 18.002 18 14.1959 18 9.50098C18 4.80602 14.194 1 9.49902 1C4.80406 1 0.998047 4.80602 0.998047 9.50098C0.998047 14.1959 4.80406 18.002 9.49902 18.002Z" stroke="#0B0204" stroke-width="1.5" stroke-miterlimit="10"/><path d="M5.75879 9.50098H13.2395" stroke="#0B0204" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/><path d="M9.49902 5.76025V13.2409" stroke="#0B0204" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/></svg>
                            </button>

                          </div>
                        </div>
                        

                        <div class="c-cart-item__right">
                          <span class="c-cart-item__remove js-cart-item-remove" role="button" tabindex="0" data-a11y-btn`+a11yCartLabel('remove', cartItem.title)+`
                              data-id="`+cartItem.id+`"
                              data-qnt="0"
                            >
                            
                            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16.0144 3.64209V15.5797C16.0144 16.5301 15.2442 17.3038 14.2904 17.3038H3.70939C2.75905 17.3038 1.98535 16.5336 1.98535 15.5797V3.64209" stroke="#0B0204" stroke-width="1.7" stroke-miterlimit="10"/>
                              <path d="M0 3.65723L18 3.66076" stroke="#0B0204" stroke-width="1.7" stroke-miterlimit="10"/>
                              <path d="M12.1671 3.66027V2.20118C12.1671 1.537 11.6301 1 10.9659 1H7.03028C6.3661 1 5.8291 1.537 5.8291 2.20118V3.66027" stroke="#0B0204" stroke-width="1.7" stroke-miterlimit="10"/>
                              <path d="M5.76953 6.55078V14.3973" stroke="#0B0204" stroke-width="1.7" stroke-miterlimit="10"/>
                              <path d="M8.99805 6.55078V14.3973" stroke="#0B0204" stroke-width="1.7" stroke-miterlimit="10"/>
                              <path d="M12.2314 6.55078V14.3973" stroke="#0B0204" stroke-width="1.7" stroke-miterlimit="10"/>
                            </svg>
                          </span>

                          <span class="c-cart-item__price">`+finalPrice+`</span>
                        </div>
                    </div>

                    <div class="c-header-cart__line"></div>
          `

          cartAjax.append(divCartItem)
          msgEmptyCart.classList.add("hide")

          let cartItemRemovesAsync = divCartItem.querySelectorAll(".js-cart-item-remove"); // solo il cestino di questa riga, non tutti
          cartItemRemovesAsync.forEach((cartItemRemove,i) => {
              cartItemRemove.addEventListener("click", (e) => {

                console.log("remove")

                  cartItemRemove.classList.add("disable")

                  let dataID = cartItemRemove.getAttribute("data-id")
                  let dataQnt = cartItemRemove.getAttribute("data-qnt")

                  let changeVariant = {
                        'id': dataID,
                        'quantity': dataQnt
                      }

                  changeCart(changeVariant, cartItemRemove, 0)
              })
          }) 
          
        })
        
        if (!cartTrigger.classList.contains("is-active")) {
          setTimeout(() => {
            cartTrigger.click()
          }, 250);
        }

        cartBtnsMinus = cartAjax.querySelectorAll(selectors.cartBtnsMinus)
        cartBtnsPlus = cartAjax.querySelectorAll(selectors.cartBtnsPlus)

        listenerMinus(cartBtnsMinus)
        listenerPlus(cartBtnsPlus)

      }).catch((error) => {
        console.error('Error:', error);
      });
      return;

    }

    function uploadCartCount(count) {
      if (parseInt(count) > 0) {
        cartCount.innerHTML = count
        cartCount.classList.remove("hide")
      } else {
        cartCount.innerHTML = ""
        cartCount.classList.add("hide")
      }

      // Aggiorna anche il counter nella modale carrello "My Cart (X items)"
      var itemsCartCount = document.querySelector(".js-items-cart-count")
      if (itemsCartCount) { itemsCartCount.innerHTML = count }
    }


    function resetCartHidden(cartItems) {
      cartInfoHidden.innerHTML = ""
      cartItems.forEach((cartItem,i) => {
        let cartHiddenEl = document.createElement('span')
        cartHiddenEl.setAttribute('class', 'js-cart-item-limit');
        cartHiddenEl.setAttribute('data-id', cartItem.id);
        cartHiddenEl.setAttribute('data-limit', "99");
        cartInfoHidden.append(cartHiddenEl)
      })
    }

  })





  })(document);

